import TablePagination from '@mui/material/TablePagination';
import { Pagination } from '@shared/model';
import { ChangeEvent } from 'react';

interface AdminClinicsPagePaginationProps extends Omit<Pagination, 'setTotal'> {}

export function AdminClinicsPagePagination({
  limit,
  total,
  page,
  changePage,
  changeRowsPerPage,
}: AdminClinicsPagePaginationProps) {
  const handleChangePage = (event: unknown, page: number) => changePage(page);

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) =>
    changeRowsPerPage(parseInt(event.target.value, 10));

  return (
    <TablePagination
      labelRowsPerPage='Клиник на странице'
      rowsPerPageOptions={[25, 50]}
      component='div'
      count={total}
      rowsPerPage={limit}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      sx={{ mb: 3 }}
    />
  );
}
